export default "__VITE_ASSET__D$tll6ms__"